"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var rows_1 = require("../rows");
var features_1 = require("../features");
exports.gridTotalId = 'grid-total-box';
var GridTotal = react_1.forwardRef(function (props, ref) {
    var _a = features_1.useGridContext().state, disabled = _a.disabled, rowHeight = _a.rowHeight, totalRow = _a.totalRow, isEmpty = _a.isEmpty, columnsWidth = _a.columnsWidth;
    var _b = features_1.useGridToggleableContext(), visibleColumns = _b.visibleColumns, rowWidth = _b.rowWidth;
    if (!totalRow) {
        return null;
    }
    return (react_1.default.createElement("div", { "data-selector-id": exports.gridTotalId, style: {
            overflow: !isEmpty ? 'hidden' : 'auto',
            flexShrink: 0
        } },
        react_1.default.createElement("div", { style: {
                width: rowWidth,
                height: rowHeight
            }, ref: ref }, rows_1.createTotalRow({
            columns: visibleColumns,
            columnsWidth: columnsWidth,
            data: totalRow,
            disabled: disabled
        }))));
});
exports.default = GridTotal;
//# sourceMappingURL=GridTotal.js.map